// @flow
import environment from '../../environment';
import { getCreator } from '../../http';
import { of } from 'rxjs';

export const endpoints = Object.freeze({
  GET_STORE: `${environment.apiUrl}/store/:name`,
  GET_USER_WISH_LIST: `${environment.apiUrl}/wishlist/:userId/:nameSlug`,
});

export const getStoreApi = getCreator(fetch, endpoints.GET_STORE);
/*
export const getStoreApi = (a: any, b: any) => of(
  {
    "type": "online-store",
    "name": "Amazon",
    "domain": "www.amazon.com",
    "logo": "https://wwwen.uni.lu/var/storage/images/media/images/lcl_images/amazon_square_logo/1285786-1-fre-FR/amazon_square_logo.png",
    "slug": "amazon",
    "categories": [
      1,
      2,
      3
    ]
  }

);
*/
export const getUserWishListApi = getCreator(fetch, endpoints.GET_USER_WISH_LIST);



// WEBPACK FOOTER //
// ./src/modules/store/api.js